import { connect } from 'react-redux'
import Trainings from './trainings'
import {
  fetchTrainings,
  filterToSchoolOrganisation,
  filterToAll
} from '../../../../stores/trainings/trainings.actions'
import {
  getFetchTrainingsRequest,
  getTrainings,
  getSchoolOrganisationFilter
} from '../../../../stores/trainings/trainings.selectors'
import { withMe } from 'pobble-components/dist/pobble-user'

const mapStateToProps = (state, { me }) => {
  const fetchTrainingsRequest = getFetchTrainingsRequest(state)
  const trainings = getTrainings(state)
  const schoolOrganisationFilter = getSchoolOrganisationFilter(state)
  const user = me.account
  return {
    noTrainings: trainings && !trainings.result.length,
    pending: !trainings || fetchTrainingsRequest.pending,
    schoolOrganisationFilter,
    schoolIsPartOfOrganisation:
      user.teacher_type &&
      user.teacher_type.school &&
      user.teacher_type.school.school_organisations &&
      user.teacher_type.school.school_organisations.filter(
        org => org.local_authority
      ).length > 0
  }
}

const mapDispatchToProps = dispatch => ({
  onMount: () => {
    return dispatch(fetchTrainings())
  },
  onSelect: (e, schoolOrganisationFilter) => {
    e === 'schoolOrganisation' && dispatch(filterToSchoolOrganisation())
    e === 'all' && dispatch(filterToAll())
    return dispatch(fetchTrainings(e === 'schoolOrganisation'))
  }
})

export default withMe(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Trainings)
)
